import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { getConnections } from "../../../actions/stats/stats";

class StatsGeneral extends React.Component {
  render() {
    const links = [
      {
        fileName: "connexions_par_clients",
        onExport: this.props.onGetConnections,
        formattedMessage: "Nb.Connections.By.Client",
      },
    ];

    const linksNode = links.map((link, index) => {
      return (
        <li key={index}>
          <button
            className="btn btn-link"
            onClick={() =>
              this.props.openConfModal(link.fileName, (successCallback) =>
                link.onExport(successCallback),
              )
            }
          >
            <FormattedMessage id={link.formattedMessage} />
          </button>
        </li>
      );
    });

    return (
      <div>
        <ul style={{ listStyleType: "none" }}>{linksNode}</ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetConnections: (successCallback) =>
      dispatch(getConnections(successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatsGeneral));
